import { useRef } from "react";
import { Box } from "@mui/material";
import "./ImageReel.scss";
import ReelElement from "./ReelElement/ReelElement";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ImageReel({ data, clickEvent, successCaseClick, reelRef }: any) {
  return (
    <Box className="reelContainer">
      <Box ref={reelRef} className="reelContainer__reel">
        {data.map((row: any, index: number) => (
          <ReelElement
            key={index}
            information={row}
            clickEvent={clickEvent}
            successCaseClick={successCaseClick}
          />
        ))}
      </Box>
    </Box>
  );
}
